import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';
import '../styles/LegalPages.css';

const TermsOfUse = () => {
  // Scroll to top on mount - immediate
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="legal-page">
      <SEO canonical="/terms-of-use" />
      <header className="legal-header">
        <div className="container">
          <Link to="/" className="legal-back-link">
            <ArrowLeft size={18} />
            <span>Back to Home</span>
          </Link>
          <Link to="/" className="legal-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_accordion-repair/artifacts/06uiebgi_Variant%201_Full%20Logo_Vector%20copy%202.png" 
              alt="All Secured" 
            />
          </Link>
        </div>
      </header>

      <main className="legal-content">
        <div className="container">
          <article className="legal-article">
            <h1>Terms of Use</h1>
            <p className="legal-effective-date">Effective Date: 12 February 2026</p>

            <section>
              <h2>1. Acceptance of Terms</h2>
              <p>By accessing or purchasing from All Secured, you agree to these Terms of Use. If you do not agree, do not use the platform.</p>
            </section>

            <section>
              <h2>2. Nature of Services</h2>
              <p>All Secured provides educational content related to cybersecurity and online privacy. Our courses:</p>
              <ul>
                <li>Are educational in nature</li>
                <li>Do not constitute legal advice</li>
                <li>Do not guarantee protection against cybercrime</li>
              </ul>
              <p>You remain responsible for your own online actions.</p>
            </section>

            <section>
              <h2>3. Account Responsibility</h2>
              <p>You are responsible for:</p>
              <ul>
                <li>Maintaining the confidentiality of your login credentials</li>
                <li>All activity under your account</li>
                <li>Providing accurate information</li>
              </ul>
              <p>We reserve the right to suspend accounts engaged in abuse or fraud.</p>
            </section>

            <section>
              <h2>4. Purchases & Refunds</h2>
              <p>Course purchases are one-time payments unless otherwise stated. Refunds may be issued in accordance with our <Link to="/refund-policy">Refund Policy</Link>. Access may be revoked if payment is refunded.</p>
            </section>

            <section>
              <h2>5. Intellectual Property</h2>
              <p>All course materials, videos, and content are the property of All Secured. You may not:</p>
              <ul>
                <li>Copy</li>
                <li>Distribute</li>
                <li>Resell</li>
                <li>Share login credentials</li>
                <li>Publicly display course content</li>
              </ul>
              <p>Unauthorised sharing may result in termination of access.</p>
            </section>

            <section>
              <h2>6. Limitation of Liability</h2>
              <p>To the maximum extent permitted by law:</p>
              <p>All Secured shall not be liable for:</p>
              <ul>
                <li>Loss of data</li>
                <li>Security breaches</li>
                <li>Indirect or consequential damages</li>
                <li>Business interruption</li>
                <li>Financial loss resulting from cybersecurity incidents</li>
              </ul>
              <p>Use of the platform is at your own risk.</p>
            </section>

            <section>
              <h2>7. Termination</h2>
              <p>We may suspend or terminate access if:</p>
              <ul>
                <li>Terms are violated</li>
                <li>Fraud or abuse is detected</li>
                <li>Payment disputes occur</li>
              </ul>
            </section>

            <section>
              <h2>8. Governing Law</h2>
              <p>These Terms are governed by the laws of Australia.</p>
            </section>
          </article>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <p>&copy; 2025 All Secured. All rights reserved.</p>
          <p className="legal-footer-stripe">Secure payments powered by Stripe.</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfUse;
